module.exports = __webpack_public_path__ + "static/Wegmans_pin_hover-55e6b7c462331d39a5bf6b161168e6f0.png";